type StoryblokMediaBlok = {
  component?: string;
  asset?: {
    filename?: string;
    is_external_url?: boolean;
  };
  poster?: {
    filename?: string;
  };
  youtube_link?: string;
};

export const usePrimaryHeroBanner = (
  blokUid: string,
  imageBlok?: StoryblokMediaBlok | null
) => {
  const primaryHeroBannerUid = useState<string | null>(
    "primary-hero-banner-uid",
    () => null
  );

  if (primaryHeroBannerUid.value === null) {
    primaryHeroBannerUid.value = blokUid;
  }

  const isPrimaryHeroBanner = computed(
    () => primaryHeroBannerUid.value === blokUid
  );

  const shouldPreconnectStoryblok = computed(() => {
    if (!isPrimaryHeroBanner.value) return false;
    return Boolean(getFacilityCarouselImageFilename(imageBlok));
  });

  useHead(() => ({
    link: shouldPreconnectStoryblok.value
      ? [{ rel: "preconnect", href: "https://a.storyblok.com" }]
      : [],
  }));

  return { isPrimaryHeroBanner };
};
